/** 과목(시간표명) 트랙 배경색을 하위 행에 얹을 때 사용하는 불투명도 */
export const SUBJECT_TRACK_CELL_TINT_ALPHA = 0.05;

export function subjectTrackTintRgba(hex: string, alpha = SUBJECT_TRACK_CELL_TINT_ALPHA): string {
  const normalized = hex.trim().replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) return `rgba(0, 0, 0, ${alpha})`;
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** 흰 배경 위 5% 틴트와 동일한 불투명 ARGB(엑셀용) */
export function subjectTrackTintArgbOnWhite(hex: string, alpha = SUBJECT_TRACK_CELL_TINT_ALPHA): string {
  const normalized = hex.trim().replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) return 'FFFFFFFF';
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  const mix = (channel: number) => Math.round(channel * alpha + 255 * (1 - alpha));
  const toHex = (n: number) => mix(n).toString(16).padStart(2, '0').toUpperCase();
  return `FF${toHex(r)}${toHex(g)}${toHex(b)}`;
}
